import React, { useEffect } from "react";
import { Card } from "../ui/card";
import { useNavigate } from "react-router-dom";

const ThankYouPage: React.FC = () => {
  const referenceNumber = Math.floor(
    1000000000000000 + Math.random() * 9000000000000000
  ).toString();
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 10000); // 10 seconds

    return () => clearTimeout(timer);
  }, [navigate]);
  return (
    <div className="h-full bg-gradient-to-br from-purple-100 to-blue-100 flex  justify-center p-6 font-sans">
      <Card className="w-full max-w-md p-6 bg-white shadow-2xl rounded-xl text-center transform transition-all duration-500 hover:scale-105">
        <div className="text-6xl text-green-500 mb-4 animate-bounce-once">
          🎉
        </div>
        <h1 className="text-4xl font-extrabold text-gray-800 mb-2 tracking-tight leading-tight">
          Thank You!
        </h1>
        <p className="text-xl text-purple-600 font-semibold mb-3">
          Your session has ended.
        </p>
        <p className="text-md text-gray-600 mb-4 leading-relaxed">
          We appreciate your valuable feedback. Your input helps us improve!
        </p>
        <div className="bg-gray-50 p-2 rounded-lg border border-gray-200 inline-block shadow-inner">
          <p className="text-sm text-gray-700 font-medium">
            Kindly note this reference number for future use:
          </p>
          <p className="text-lg font-bold text-blue-700 mt-1 select-all">
            {referenceNumber}
          </p>
        </div>
        <div className="">
          <p className="text-sm text-gray-500">
            You can close this window now.
          </p>
        </div>
      </Card>
    </div>
  );
};

export default ThankYouPage;
